module.exports = __webpack_public_path__ + "img/T1C_rc_26.b8132cbd.png";